import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import type {EntityDraftSkeletonProps} from './entity-draft-skeleton.types';
import {EntityDraftSkeleton} from './entity-draft-skeleton';

export const entityDraftSkeletonRegistration = defineStreamComponentRegistration(
  StreamComponentType.ENTITY_DRAFT_SKELETON,
  EntityDraftSkeleton,
  (): EntityDraftSkeletonProps => ({})
);
